import React, { useContext } from 'react';
import {
  BaseShowcaseQuerySectionData,
  ShowcaseListRenderComponentType,
} from 'src/modules/materials/models/showcase';
import { SliderSectionRender } from 'src/modules/materials/components/ShowcasePage/renderers/SliderSectionRender';
import { useNeauviaItemsListQuery } from 'src/modules/materials/hooks/useNeauviaItemsListQuery';
import { ShowcaseContext } from 'src/modules/materials/providers/ShowcaseContext';

export const SliderQueryContainer = ({
  section,
  render: Render = SliderSectionRender,
}: {
  section: BaseShowcaseQuerySectionData;
  render?: ShowcaseListRenderComponentType;
}) => {
  const { itemsToQuery } = useContext(ShowcaseContext);
  const items = useNeauviaItemsListQuery({
    itemsToQuery,
    ...section.variables,
  });

  if (!items.isLoading && items.data?.length === 0) {
    return null;
  }

  return (
    <Render section={section} items={items.data} isLoading={items.isLoading} />
  );
};
